import React from 'react'
import { Skeleton, Stack, Box } from '@machobear/design-system'

const AutoReplyEmptyComponent = () => (
  <Box
    display="flex"
    justifyContent="spaceBetween"
    alignItems="center"
    padding="small"
    boxShadow="small"
    border="borderNeutralLight"
    borderRadius="standard"
  >
    <Box width="full">
      <Stack space="xsmall">
        <Skeleton.Shape height={24} width={'30%'} />
        <Skeleton.Shape height={24} width={'60%'} />
      </Stack>
    </Box>
    <Box style={{ width: 104 }}>
      <Skeleton.Shape height={44} width={'100%'} />
    </Box>
  </Box>
)
const LoadingAutoReply = () => {
  return (
    <Box role={'status'}>
      <Stack space={'medium'}>
        <Skeleton.Shape height={24} width={'20%'} />
        <AutoReplyEmptyComponent />
        <AutoReplyEmptyComponent />
        <AutoReplyEmptyComponent />
      </Stack>
    </Box>
  )
}

export default LoadingAutoReply
